<!--
 * @Author: your name
 * @Date: 2021-04-27 09:22:05
 * @LastEditTime: 2021-05-25 17:42:12
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /youhuaguo-ui/src/views/business/rebates/component/list.vue
-->
<template>
  <div>
    <el-form :inline="true" :model="formInline" class="demo-form-inline">
      <el-form-item>
        <el-input clearable @keyup.enter.native="onSubmit" style="width:280px;" v-model="formInline.code" placeholder="返点编号"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input clearable @keyup.enter.native="onSubmit" style="width:280px;" v-model="formInline.putInRecordCode" placeholder="投放编号"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input clearable @keyup.enter.native="onSubmit" style="width:280px;" v-model="formInline.mediaName" placeholder="博主账号名称"></el-input>
      </el-form-item>
      <el-form-item>
        <el-select clearable style="width:280px;" v-model="formInline.mediaType" placeholder="平台">
          <el-option v-for="item in pingtaiList" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-input clearable @keyup.enter.native="onSubmit" style="width:280px;" v-model="formInline.contractNameOrCode" placeholder="合同名称/编号"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input clearable @keyup.enter.native="onSubmit" style="width:280px;" v-model="formInline.customerName" placeholder="客户名称"></el-input>
      </el-form-item>
      <el-form-item>
        <el-date-picker
          clearable
          value-format="yyyy-MM-dd HH:mm:ss"
          :default-time="['00:00:00', '23:59:59']"
          style="width:280px;"
          v-model="timeData"
          type="datetimerange"
          range-separator="~"
          start-placeholder="最早发布时间"
          end-placeholder="最晚发布时间">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">搜 索</el-button>
      </el-form-item>
    </el-form>
    <div style="padding-bottom:20px;">投放总数：{{total}}条</div>
    <el-table size="small" :data="tableData" style="width: 100%">
      <el-table-column align="center" prop="code" label="返点编号"></el-table-column>
      <el-table-column align="center" prop="rebateMoney" label="返点金额"></el-table-column>
      <el-table-column align="center" prop="putInRecordCode" label="所属投放记录编号"></el-table-column>
      <el-table-column align="center" prop="date" label="博主账号名称" width="200">
        <template slot-scope="scope">
          <!-- <div class="headerNamer">
            <div style="width:40px;height:40px;margin-right:10px;">
              <img style="width:100%;height:100%;border-radius:40px;" :src="scope.row.avatar" alt="">
            </div>
            <div>{{scope.row.mediaName}}</div>
          </div> -->
          <div class="account-wrap">
            <div class="avatar-out">
              <div class="avatar-in">
                <div class="img-wrap" v-if="scope.row.avatar">
                  <!--有头像-->
                  <img v-if="scope.row.avatar.indexOf('/qr/code') !== -1" :src="scope.row.avatar" onerror="javascript:this.src='/img/media/wechat_default.png';" class="avatar is-code">
                  <img v-else :src="scope.row.avatar" onerror="javascript:this.src='/img/media/weibo_default.png';" class="avatar">
                </div>
                <div class="img-wrap" v-else>
                  <img src="/img/media/weibo_default.png" class="avatar">
                </div>
              </div>
            </div>
            <div class="info-wrap">
              <el-tooltip :content="scope.row.mediaName" placement="bottom" effect="light">
                <div class="nickname"><span>{{ scope.row.mediaName }}</span></div>
              </el-tooltip>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="mediaType" label="平台">
        <template slot-scope="scope">
          {{getMediaType[scope.row.mediaType]}}
        </template>
      </el-table-column>
      <el-table-column align="center" prop="contractName" label="关联合同"></el-table-column>
      <el-table-column align="center" prop="customerName" label="客户名称"></el-table-column>
      <el-table-column align="center" prop="publishType" label="发布形式">
        <template slot-scope="scope">
          {{scope.row.publishType || '--'}}
        </template>
      </el-table-column>
      <el-table-column align="center" prop="publishTime" label="发布日期">
         <template slot-scope="scope">
          {{scope.row.publishTime || '--'}}
        </template>
      </el-table-column>
      <el-table-column align="center" prop="status" label="返点状态">
        <template slot-scope="scope">
          {{scope.row.status==0?'未返点':'已返点'}}
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作">
        <template slot-scope="scope">
          <el-button v-if="scope.row.status == 0" type="text" size="small" @click="saveRebates(scope.row.id)">确认返点</el-button>
          <el-button v-else type="text" size="small" @click="detailsRebates(scope.row.id)">返点详情</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <div style="text-align:right;">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="formInline.pageNum"
        :page-sizes="[10, 20, 30, 40, 50, 100]"
        :page-size="formInline.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!-- 确认返点 -->
    <el-dialog :title="dialogTitle" width="30%" :visible.sync="dialogTableVisible">
      <el-form v-if="dialogTitle==='确认返点'" label-position="left" :model="ruleForm" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="返点凭证：" prop="voucherPath">
          <el-upload :id="'upload-file-3'" :key="'file-3'" class="upload-demo" :action="'https://upload-z2.qiniup.com'" :on-success="uploadSuccess" :on-error="uploadError"
            :before-upload="beforeUpload" :show-file-list="false">
            <div style="color:#409eff;" v-if="ruleForm.voucherPath">{{ruleForm.voucherName}}</div>
            <el-button v-else size="small" type="primary" class="btn--green" icon="el-icon-plus">上传返点凭证</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="返点备注：">
          <el-input type="textarea" v-model="ruleForm.remark" rows="4" show-word-limit placeholder="请输入返点备注" maxlength="100"></el-input>
        </el-form-item>
        <div style="margin-top:20px;text-align:center;">
          <el-button type="primary" @click="saveClick()" style="margin-right:60px;">确 定</el-button>
          <el-button plain @click="dialogTableVisible = false">取 消</el-button>
        </div>
      </el-form>
      <el-form v-else :model="rebatesDetails" label-position="left" label-width="120px" size="mini">
        <el-form-item label="返点凭证：">
          <a class="link" href="javascript:void(0);" @click="downloadFile(rebatesDetails.voucherPath, rebatesDetails.voucherName)" :download="rebatesDetails.voucherPath">{{ rebatesDetails.voucherName }}</a>
        </el-form-item>
        <el-form-item label="返点备注：">
          <div>{{rebatesDetails.remark}}</div>
        </el-form-item>
        <el-form-item label="返点确认人：">
          <div>{{rebatesDetails.confirmUserName}}</div>
        </el-form-item>
        <el-form-item label="返点确认时间：">
          <div>{{rebatesDetails.confirmTime}}</div>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import { putInRecordRebateList, putInRecordRebateDetail, putInRecordRebateConfirm } from "../api";
import { qiniuToken } from "@/api/index";
import * as qiniu from "qiniu-js";
export default {
  data() {
    return {
      dialogTitle:"",
      total: 0,
      timeData:[],
      formInline: {
        code:"",
        contractNameOrCode:"",
        customerName:"",
        endTime:"",
        mediaName:"",
        mediaType:"",
        putInRecordCode:"",
        startTime:"",
        pageNum: 1,
        pageSize: 10,
      },
      dialogTableVisible:false,
      ruleForm:{
        id:"",
        remark:"",
        voucherName:"",
        voucherPath:"",
      },
      getMediaType:['','微信','微博','小红书','抖音','B站','快手','淘宝直播'],
      pingtaiList:[
        {value: 1,label: '微信'},
        {value: 2,label: '微博'},
        {value: 3,label: '小红书'},
        {value: 4,label: '抖音'},
        {value: 5,label: 'B站'},
        {value: 6,label: '快手'},
        {value: 7,label: '淘宝直播'},
      ],
      tableData: [],
      rebatesDetails:{}
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList(){
      putInRecordRebateList(this.formInline).then(res=>{
        this.tableData = res.data;
        this.total = res.total;
        console.log('=======返点列表======',res)
      })
    },
    //确认返点
    saveRebates(id){
      this.dialogTitle = '确认返点'
      this.dialogTableVisible = true
      this.ruleForm.id = id;
    },
    //保存确认 返点
    saveClick(){
      putInRecordRebateConfirm(this.ruleForm).then(res=>{
        if(res.code === 1){
          this.$message({
            message: '确认返点成功!',
            type: 'success'
          });
          this.dialogTableVisible = false
          this.getList();
        }
        console.log('=======确认返点成功=====',res)
      })
    },
    //返点详情
    detailsRebates(id){
      this.dialogTitle = '返点详情';
      this.dialogTableVisible = true;
      putInRecordRebateDetail({id:id}).then(res=>{
        this.rebatesDetails = res.data;
        console.log('========详情=======',res)
      })
    },
    onSubmit(){
      if(this.timeData){
        this.formInline.startTime = this.timeData[0]
        this.formInline.endTime = this.timeData[1]
      }else{
        this.formInline.startTime = ""
        this.formInline.endTime = ""
      }
      console.log('=====事件=====',this.formInline)
      this.getList()
    },
    handleSizeChange(val){
      this.getList()
      this.formInline.pageSize = val;
    },
    handleCurrentChange(val){
      this.getList()
      this.formInline.pageNum = val;
    },
    //上传文件成功
    uploadSuccess(res, file) {
      // file 返回的文件信息，也可以在这里调用七牛上传。
      console.log(file, "success");
    },
    //上传文件失败
    uploadError(res, file) {
      console.log("error", res, file);
    },
    //文件上传
    beforeUpload(file) {
      if (file.size > 500 * 1024 * 1024) {
        this.$message.error("文件大小不能超过500M");
        return false;
      }
      qiniuToken()
        .then((res) => {
          let that = this;
          let fileName = Date.now() + file.name;
          var observable = qiniu.upload(file, fileName, res.data);
          observable.subscribe({
            next(res) {},
            error(error) {
              this.$message.error("上传失败");
            },
            complete: (complete) => {
              let qiniuBaseUrl = "https://yhgtk.fruitbloom.com.cn/";
              this.$set(this.ruleForm, "voucherName", file.name);
              this.$set(this.ruleForm, "voucherPath", qiniuBaseUrl + complete.key);
            },
          });
        })
        .catch((error) => {});
      return false;
    },
  },
};
</script>
<style lang="scss" scoped>
.headerNamer{
  margin-left: 20px;
  display: flex;
  align-items: center;
}
.account-wrap {
    display: flex;
    cursor: pointer;
    //头像
    .avatar-out {
      /*width: 50%;*/
      display: flex;
      justify-content: flex-end;
      align-items: center;
      .avatar-in {
        position: relative;
        width: 42px;
        height: 42px;
        margin-right: 10px;
        float: right;
        .img-wrap {
          position: relative;
          border-radius: 50%;
          width: 42px;
          height: 42px;
          overflow: hidden;
          img {
            width: 100%;
            height: 100%;
            &.is-code {
              position: absolute;
              top: -84px;
              left: -84px;
              width: 210px;
              height: 210px;
            }
          }
        }
      }
    }
    //基础信息
    .info-wrap {
      display: flex;
      align-items: center;
      width: 50%;
      font-size: 12px;
      text-align: left;
      .nickname {
        max-width: 65px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
</style>